var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { getVariantComponent } from './utils/getVariantComponent';
const Typography = (_a) => {
    var { className, class: extraClassName, children, variant = 'body-text', tagName, inputRef, dataTest } = _a, remainingProps = __rest(_a, ["className", "class", "children", "variant", "tagName", "inputRef", "dataTest"]);
    /**
     * All variants are configured in the `./configurations` directory.
     */
    const StyledComponent = getVariantComponent(variant);
    const classes = classNames(className, extraClassName);
    return (React.createElement(StyledComponent, Object.assign({ ref: inputRef, className: classes, as: tagName, "data-test": (dataTest || variant), "data-variant": variant }, remainingProps), children));
};
export default Typography;
//# sourceMappingURL=Typography.js.map